import React from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';
import NumberFormat, { NumberFormatProps } from 'react-number-format';

export type NumberMaskedFieldProps = TextFieldProps & {
  MaskedProps?: NumberFormatProps;
};

export const NumberMaskedField = ({ MaskedProps, ...props }: NumberMaskedFieldProps): JSX.Element => {
  const { size, ...rest } = props;
  return (
    <NumberFormat
      {...MaskedProps}
      {...(rest as any)}
      customInput={TextField}
      size={size as 'small' | 'medium' | undefined}
    />
  );
};

export default NumberMaskedField;
